export const BASE_URL = process.env.REACT_APP_BASE_URL

// API host root, without the trailing /api segment. v1 endpoints (e.g.
// /v1/auth/..., /v1/consent/...) live here rather than under /api.
export const API_ORIGIN = (BASE_URL || '').replace(/\/api$/, '')
